import React, { Component } from 'react'
import { compose } from 'redux'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import { Row, Col, Card, CardBody, Button, UncontrolledTooltip, Collapse } from 'reactstrap'
import ReactTable from 'react-table'
import _ from 'lodash'

import SearchForm from 'components/searchForm'
import PageTitle from 'components/Title/PageTitle'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import ConfirmationModal from 'components/Modal/confirmation'
import DesignationForm from './Form'
import Pagination from 'components/Pagination'

import DesignationsHOC from './actions'

class Designations extends Component {

  componentDidUpdate = pp => {
    if ( pp.currentPermission !== this.props.currentPermission && this.props.currentPermission.is_read ){
      this.props.getDesignations(btoa(`{"page":1}`))
    }
  }

  render = () => {
    const { is_create, is_delete, is_update } = this.props.currentPermission

    return (
      <>
        <PageTitle
          heading="Designations"
          subheading="Listings of all the designations present in the system."
          icon="pe-7s-id icon-gradient bg-happy-itmeo"
          buttons={[
            {
              color: 'warning',
              className: 'btn-icon mr-2',
              onClick: () => {
                this.props.onChangeDesignationsHOC( 'showSearchForms', !this.props.showSearchForms )
              },
              content:<>
                <i className="pe-7s-search btn-icon-wrapper"> </i>
                <span>Search</span>
              </>
            },
            ... ( is_create ? [{
              color: 'primary',
              onClick: () => {
                this.props.onChangeDesignationsHOC( 'showCreateDesignationsModal', true )
              },
              content: 'Create'
            }] : [])
          ]} />
        <ReactCSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}>
          <Collapse
            isOpen={ this.props.showSearchForms }
            onExiting={ () => this.props.onChangeDesignationsHOC( 'showSearchForms', false )}
          >
            <SearchForm
              searchParams={ this.props.searchParams }
              onChangeHOCState={ this.props.onChangeDesignationsHOC }
              getListAPI={ this.props.getDesignations }
            />
          </Collapse>
          <Row>
            <Col md={12}>
              <Card className="main-card mb-3">
                <CardBody>
                  <ReactTable
                    pageSize={ 
                      this.props.designations.data.length < 1? 3: 
                      this.props.designations.data.length < 10? this.props.designations.data.length:
                      10
                    }
                    data={ this.props.designations.data }
                    columns={[
                      {
                        Header: 'Name',
                        accessor: 'name'
                      },
                      {
                        Header: 'Actions',
                        Cell: (row) => {
                          return (
                            <>
                              <Button
                                id="UpdateDesignation"
                                className="mr-2 btn-icon btn-icon-only"
                                color={ is_update ? "primary" : 'secondary' }
                                disabled={ !is_update }
                                onClick={() => {
                                  this.props.getSelectedDesignation(row.original.id, 'edit' )
                                }}>
                                <i className="pe-7s-pen btn-icon-wrapper"> </i>
                              </Button>
                              <UncontrolledTooltip target="UpdateDesignation" placement="left">Update the information of this designation</UncontrolledTooltip>
                              <Button
                                id="DeleteDesignation"
                                className="mr-2 btn-icon btn-icon-only"
                                color={ is_delete ? "danger" : 'secondary' }
                                disabled={ !is_delete }
                                onClick={() => {
                                  this.props.onChangeDesignationsHOC( 'showDeleteDesignationModal', true )
                                  this.props.onChangeDesignationsHOC( 'selectedDeleteDesignationId', row.original.id )
                                }}>
                                <i className="pe-7s-close btn-icon-wrapper"> </i>
                              </Button>
                              <UncontrolledTooltip target="DeleteDesignation" placement="left">Delete this Designation</UncontrolledTooltip>
                            </>
                          )
                        }
                      }
                    ]}
                    showPagination={false} />
                  <Pagination 
                    metadata={ this.props.designations.meta } 
                    onChangePage={ pg => {
                      const { search } = this.props.data.LastViewReducer.lastView
                      let tempJSON = JSON.parse( atob( search ))
                      tempJSON.page = pg
                      
                      this.props.getDesignations( btoa( JSON.stringify( tempJSON )))
                    }} />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <DesignationForm
            {...this.props}
            mode={ 'Create' }
            open={ this.props.showCreateDesignationsModal }
            onClose={ () => this.props.onChangeDesignationsHOC( 'showCreateDesignationsModal', false )}
            onClickSubmit={ this.props.createDesignation }
          />
          <DesignationForm
            {...this.props}
            mode={ 'Edit' }
            selectedFormData={ this.props.selectedDesignation }
            open={ this.props.showUpdateDesignationsModal }
            onClose={ () => this.props.onChangeDesignationsHOC( 'showUpdateDesignationsModal', false )}
            onClickSubmit={ this.props.updateDesignation }
          />
          <ConfirmationModal
            open={ this.props.showDeleteDesignationModal }
            title={ `Delete Designation` }
            loading={ this.props.onLoadDesignation }
            message={ `Are you sure you want to delete this designation? (This process can't be undone)` }
          
            onClose={ () => this.props.onChangeDesignationsHOC( 'showDeleteDesignationModal', false )}
            onClickConfirm={ () => this.props.deleteDesignation( this.props.selectedDeleteDesignationId )}/>
        </ReactCSSTransitionGroup>
        { this.props.onLoadDesignation && <LoadingOverlay />}
      </>
    )
  }
}

export default compose(
  DesignationsHOC
)(Designations)